/**
 * Dolibarr job tags (user categories « easer clean », « easer green », « Easer DIY »…) shown as short labels
 * (Clean / Green / DIY). One visual identity per trade, reused by every admin / Easer screen.
 */
export const tagKey = (tag) => String(tag || '').trim().toLowerCase();

const STYLES = {
  clean: {
    badge: 'border-[hsl(var(--job-clean))]/40 text-[hsl(var(--job-clean))] bg-[hsl(var(--job-clean))]/10',
    chip: 'bg-[hsl(var(--job-clean))]/12 text-[hsl(var(--job-clean))] border-[hsl(var(--job-clean))]/40',
    accent: 'border-l-[hsl(var(--job-clean))]',
    dot: 'bg-[hsl(var(--job-clean))]',
    cell: 'bg-[hsl(var(--job-clean))]/15',
  },
  green: {
    badge: 'border-[hsl(var(--job-green))]/40 text-[hsl(var(--job-green))] bg-[hsl(var(--job-green))]/10',
    chip: 'bg-[hsl(var(--job-green))]/12 text-[hsl(var(--job-green))] border-[hsl(var(--job-green))]/40',
    accent: 'border-l-[hsl(var(--job-green))]',
    dot: 'bg-[hsl(var(--job-green))]',
    cell: 'bg-[hsl(var(--job-green))]/15',
  },
  diy: {
    badge: 'border-[hsl(var(--job-diy))]/40 text-[hsl(var(--job-diy))] bg-[hsl(var(--job-diy))]/10',
    chip: 'bg-[hsl(var(--job-diy))]/12 text-[hsl(var(--job-diy))] border-[hsl(var(--job-diy))]/40',
    accent: 'border-l-[hsl(var(--job-diy))]',
    dot: 'bg-[hsl(var(--job-diy))]',
    cell: 'bg-[hsl(var(--job-diy))]/15',
  },
};

const FALLBACK = {
  badge: 'border-border text-muted-foreground bg-secondary/60',
  chip: 'bg-secondary text-foreground border-border',
  accent: 'border-l-border',
  dot: 'bg-muted-foreground',
  cell: 'bg-secondary/50',
};

export const tagStyle = (tag) => STYLES[tagKey(tag)] || FALLBACK;

/** Primary trade of an Easer = first tag (Dolibarr order), used for the row colour. */
export const primaryTag = (tags) => (Array.isArray(tags) && tags.length ? tags[0] : null);

/** Distinct tags present in a list of rows with a `tags` array, in a stable order (clean, green, diy, others). */
export const collectTags = (rows) => {
  const order = ['clean', 'green', 'diy'];
  const seen = new Map();
  (rows || []).forEach((r) => (r.tags || []).forEach((t) => { if (!seen.has(tagKey(t))) seen.set(tagKey(t), t); }));
  return [...seen.values()].sort((a, b) => {
    const ia = order.indexOf(tagKey(a)); const ib = order.indexOf(tagKey(b));
    return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib) || a.localeCompare(b);
  });
};
